import { ComponentOnBoardingOnBoardingContainer } from '../../../graphql/generated/graphql';
import { useEffect, useState } from 'react';
import useMarkStepDone from './useMarkStepDone';
import { useNavigate } from 'react-router-dom';
import useOnBoardingPage from './useOnBoardingPage';

export const useOnBoarding = <
  T extends {
    content?: ComponentOnBoardingOnBoardingContainer | null;
  },
>({
  fetchFn,
}: {
  fetchFn: (() => Promise<unknown>) | null;
}) => {
  const router = useNavigate();
  const [response, setResponse] = useState<T>({} as T);
  const { markStepDone, checkCurrentStep } = useMarkStepDone();
  const { page } = useOnBoardingPage();

  useEffect(() => {
    (async () => {
      checkCurrentStep();
      if (!fetchFn) return;
      const result = await fetchFn();
      setResponse(result as T);
    })();
  }, [checkCurrentStep, fetchFn]);

  const handleNext = (url?: string) => {
    const nextUrl = url ? url : response?.content?.button?.link || '#';
    markStepDone(nextUrl);
    router(nextUrl);
  };

  return {
    response,
    handleNext,
    page,
  };
};
